//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'IAIHG',
  data () {
    return {
      form: {
        female: '0',
        alp_ast: '',
        y_igg: '',
        ana_asma: '',
        ama_positive: '0',
        hepatitis: '',
        medication: '',
        alcohol: '',
        liver: '',
        immune: '0',
        specific: '0',
        hla_dr3: '0',
        treatment: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '2', name: '＜1.5'},
        {value: '0', name: '1.5~3.0'},
        {value: '-2', name: '＞3.0'},
      ],
      dataList2: [
        {value: '3', name: '＞2.0'},
        {value: '2', name: '1.5~2.0'},
        {value: '1', name: '1.0~1.5'},
        {value: '0', name: '＜1.0'}
      ],
      dataList3: [
        {value: '3', name: '＞1:80'},
        {value: '2', name: '1:80'},
        {value: '1', name: '1:40'},
        {value: '0', name: '＜1:40'}
      ],
      dataList4: [
        {value: '-3', name: '阳性'},
        {value: '3', name: '阴性'}
      ],
      dataList5: [
        {value: '-4', name: '阳性'},
        {value: '1', name: '阴性'}
      ],
      dataList6: [
        {value: '2', name: '＜25g/d'},
        {value: '-2', name: '＞60g/d'}
      ],
      dataList7: [
        {value: '3', name: '界面性肝炎'},
        {value: '1', name: '淋巴-浆细胞浸润为主或玫瑰花环样改变'},
        {value: '-5', name: '无上述病变'},
        {value: '-3', name: '胆道改变或其他改变'},
      ],
      dataList8: [
        {value: '2', name: '有效'},
        {value: '3', name: '复发'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result = form.female * 2 + form.alp_ast + form.y_igg + form.ana_asma + form.ama_positive * (-4) + form.hepatitis + form.medication + form.alcohol + form.liver + form.immune * 2 + form.specific * 2 + form.hla_dr3 + form.treatment

        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/IAIHG.vue